<template>
  <div v-if="!onlyShowVagues">
    <div class="row">
      <div class="col-lg-2"> </div>
      <div class="col-lg-6 text-left">
        <label class="bold">Liste des vagues actives :</label>
        <div  v-for="(vague, index) in vaguesActives" :key="index">
          {{ vague }}
        </div>
      </div>
    </div>
  </div>



  <div class="row">
    <div v-if="!onlyShowDate1" class="col-lg-6">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Du:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
    <div v-if="!onlyShowDate2" class="col-lg-6">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Au:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Assuming you want to align Nombre de détaillants as well -->
  <div v-if="!onlyShowTirage" class="row">
    <div class="col-lg-6">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Nombre de détaillants :</label>
        </div>
        <div class="col-lg-9">
          <InputNumber
              class="input-width-100"
              v-model="nombreATirer"
              size="10"
              :min="1"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheClientMystere",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  props: {
    onlyShowDate1: {
      type: Boolean,
      default: true
    },
    onlyShowDate2: {
      type: Boolean,
      default: true
    },
    onlyShowTirage: {
      type: Boolean,
      default: true
    },
    onlyShowVagues: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dateDu: null,
      dateAu: null,
      vaguesActives: [],
      nombreATirer: 600,

      criteresRecherche: {},
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  beforeMount() {
    this.dateDefault();
  },
  methods: {
    assignerListe(val) {
      Object.values(val).forEach(vague => {
        this.vaguesActives.push(vague);
      });
    },
    imprimer() {
      this.$emit("imprimer");
    },
    fermer() {
      this.$store.commit("autoexclusion/NARRATION_STORE_STATE_RESET");
      this.$emit('fermer');
    },
    getCriteresRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.criteresRecherche.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.criteresRecherche.dateDu = new Date(this.dateDu);
      }
      this.criteresRecherche.nombreATirer = this.nombreATirer

      return this.criteresRecherche;
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 30));
      this.dateAu = this.$commun.formatDate(new Date());
    },
  },

}
</script>